import React, { useState, useEffect } from "react";
import { Button, Spinner } from "react-bootstrap";
import { useSearchParams, useNavigate } from "react-router-dom";

import axios from "axios";

import { useSelector, useDispatch } from "react-redux";
import { fetchSubscriptionDetails } from "../../store/slice/subscriptionSlice";
import {
  setShowErrorModal,
  setShowSuccessModal,
} from "../../store/slice/modalSlice";

import { updatePlanName } from "../../store/slice/subscriptionSlice";

import { getUrl, getStripeUrl } from "../../helpers/url";

import { useCmsHook } from "../../helpers/cmsHook";

const PostpaidBilling = () => {
  const { cmsInstance } = useCmsHook();

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const dispatch = useDispatch();

  const [upgradeLoading, setUpgradeLoading] = useState(false);
  const [downgradeLoading, setDowngradeLoading] = useState(false);

  const subscriptionData = useSelector((state) => state.subscription);
  const {
    cardsData,
    subscription: { planData },
  } = subscriptionData;

  const onUpgradePlan = async () => {
    try {
      setUpgradeLoading(true);
      const companyId = searchParams.get("companyId");
      const userId = searchParams.get("userId");
      let customerKey = planData.customerKey;

      if (customerKey === "undefined" || customerKey === "") {
        const { data: customer } = await axios.post(
          getStripeUrl("REACT_APP_CREATE_CUSTOMER"),
          {
            appSlug: "pipedriveCompanyLookup",
            metaData: { pipedriveUserId: userId },
          }
        );
        dispatch(fetchSubscriptionDetails(companyId));
        customerKey = customer.id;
      }

      const { data: res } = await axios.post(
        getStripeUrl("REACT_APP_STRIPE_CHECKOUT"),
        {
          customerKey,
          appSlug: "pipedriveCompanyLookup",
          plan: "premium",
          successUrl: `${
            window.location.href.split("?")[0]
          }?companyId=${companyId}&userId=${userId}&paymentStatus=cardAdded`,
          cancelUrl: `${
            window.location.href.split("?")[0]
          }?companyId=${companyId}&userId=${userId}&paymentStatus=failed`,
          subscriptionData: {
            description: `Subscription active for the company ${companyId}`,
            metaData: {
              companyId,
            },
          },
        }
      );

      if (res.url) {
        window.open(res.url, "_self");
      } else {
        navigate(
          `..${window.location.pathname}?companyId=${companyId}&userId=${userId}&paymentStatus=none`
        );
      }
    } catch (error) {
      console.log(error);
      let errorMessage;
      if (error.response && error.response.data.message)
        errorMessage = error.response.data.message;
      else errorMessage = error.message;
      dispatch(
        setShowErrorModal({
          message: errorMessage,
        })
      );
    } finally {
      setUpgradeLoading(false);
    }
  };

  const paymentStatusCheck = async () => {
    const companyId = searchParams.get("companyId");
    const userId = searchParams.get("userId");
    const paymentStatus = searchParams.get("paymentStatus");
    if (paymentStatus === "cardAdded") {
      dispatch(updatePlanName({ plan: "premium" }));
      navigate(
        `..${window.location.pathname}?companyId=${companyId}&userId=${userId}&paymentStatus=none`
      );
      dispatch(
        setShowSuccessModal({
          message:
            "cmsContent.notifications.subscriptionPage.successContent.upgradePlan.message",
        })
      );
    } else if (paymentStatus === "failed") {
      dispatch(
        setShowErrorModal({
          message:
            "cmsContent.notifications.subscriptionPage.failContent.paymentFailed.message",
        })
      );
    }
  };

  const onCancelSubscription = async () => {
    try {
      setDowngradeLoading(true);
      const companyId = searchParams.get("companyId");
      const userId = searchParams.get("userId");
      await axios.post(getUrl("REACT_APP_CANCEL_SUBSCRIPTION"), {
        companyId,
        userId,
      });
      dispatch(fetchSubscriptionDetails(companyId));
      dispatch(
        setShowSuccessModal({
          message:
            "cmsContent.notifications.subscriptionPage.successContent.cancelSubscription.message",
        })
      );
    } catch (error) {
      console.log(error);
      let errorMessage;
      if (error.response && error.response.data.message)
        errorMessage = error.response.data.message;
      else errorMessage = error.message;
      dispatch(
        setShowErrorModal({
          message: errorMessage,
        })
      );
    } finally {
      setDowngradeLoading(false);
    }
  };

  useEffect(() => {
    if (cmsInstance) paymentStatusCheck();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderButtons = (card, upgradeLoading, downgradeLoading) => {
    if (
      (planData.plan === "basic" || planData.plan === "Basic") &&
      card.name === "Free Trial"
    ) {
      return (
        <>
          {planData.usageCount >= 15 ? (
            <Button className="pricing-card-button-disable mt-3 mb-3" disabled>
              Trial Expired
            </Button>
          ) : (
            <Button className="pricing-card-button-disable mt-3 mb-3" disabled>
              Selected
            </Button>
          )}
        </>
      );
    } else if (
      (planData.plan === "basic" || planData.plan === "Basic") &&
      card.name === "Premium"
    ) {
      return (
        <Button
          className="pricing-card-button mt-3 mb-3"
          disabled={upgradeLoading}
          onClick={onUpgradePlan}
        >
          {upgradeLoading ? (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          ) : (
            <span>Upgrade</span>
          )}
        </Button>
      );
    } else if (
      (planData.plan === "premium" || planData.plan === "Premium") &&
      card.name === "Premium"
    ) {
      return (
        <>
          <Button disabled className="pricing-card-button-disable mt-3 mb-3">
            Selected
          </Button>
          <Button
            className="pricing-card-cancel-button"
            onClick={onCancelSubscription}
            disabled={downgradeLoading}
          >
            {downgradeLoading ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              <span>Cancel Subscription</span>
            )}
          </Button>
        </>
      );
    } else if (
      (planData.plan === "premium-cancelled" ||
        planData.plan === "Premium-Cancelled") &&
      card.name === "Premium"
    ) {
      return (
        <Button
          className="mt-3 mb-3 pricing-card-button"
          disabled={upgradeLoading}
          onClick={onUpgradePlan}
        >
          {upgradeLoading ? (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          ) : (
            <span>Upgrade</span>
          )}
        </Button>
      );
    }
  };

  return (
    <ul
      className={`pricing-cards-container ${
        (planData.plan === "premium" ||
          planData.plan === "premium-cancelled") &&
        "d-flex flex-row justify-content-center"
      }`}
    >
      {cardsData &&
        cardsData.map((card) => (
          // rendering the pricing cards by iterating over the pricingCardData array.
          <li
            key={card.id}
            className={`pricing-card ${
              (planData.plan === "premium" ||
                planData.plan === "premium-cancelled") &&
              card.name === "Free Trial" &&
              "d-none"
            }`}
          >
            {/* <h5 className="pricing-card-name">{card.name}</h5>
            <p className="pricing-card-text">{card.text}</p>
            <h5 className="pricing-card-price">
              {card.price}
              <span className="pricing-card-price-tag">
                {card.name !== "Free Trial" ? "/mo" : ""}
              </span>
            </h5> */}
            {cmsInstance &&
              cmsInstance.showRichText(
                `cmsContent.subscription.cards.${card.path}.text`
              )}
            {renderButtons(card, upgradeLoading, downgradeLoading)}
            {cmsInstance &&
              cmsInstance.showRichText(
                `cmsContent.subscription.cards.${card.path}.points`
              )}
            {/* <ul className="card-points-container mt-3">
              {card.points.map((point, index) => (
                // List of points present in each card
                <li key={index} className="card-point my-2 mx-4">
                  <p className="d-flex flex-row">
                    <span>
                      <AiOutlineCheck className="card-icon me-2" />
                    </span>
                    <span>{point}</span>
                  </p>
                </li>
              ))}
            </ul> */}
          </li>
        ))}
    </ul>
  );
};

export default PostpaidBilling;
